import create from "zustand";

const useStatsStore = create((set) => ({
    servertime: Math.floor(Date.now() / 1000),
    lastseen: {},
    lastseenip: {},
    stats: {},
    assigned: {},
    assignments: [],
    setServertime: (servertime) => set({ servertime }),
    setLastSeen: (lastseen) => set({ lastseen }),
    setLastSeenIp: (lastseenip) => set({ lastseenip }),
    setStats: (stats) => set({ stats }),
    setAssigned: (assigned) => set({ assigned }),
    setAssignments: (assignments) => set({ assignments }),
}))
export default useStatsStore